
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class ApprovalInItemsGrid extends Serenity.EntityGrid<ApprovalInItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.ApprovalInItems'; }
        protected getDialogType() { return ApprovalInItemsDialog; }
        protected getIdProperty() { return ApprovalInItemsRow.idProperty; }
        protected getInsertPermission() { return ApprovalInItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return ApprovalInItemsRow.localTextPrefix; }
        protected getService() { return ApprovalInItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}
